const formatPrice = (value) =>
  `$${value.toLocaleString("es-AR", { minimumFractionDigits: 0 })}`;

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const presentationLabels = {
  PORCIONES_4: "Porciones x4",
  PORCIONES_8: "Porciones x8",
  PIZZERIA_6PACK: "Pack pizzeria x6",
};

const getPrice = (producto, presentation) => {
  const presentationPrices = producto.precios || producto.prices || null;
  if (presentationPrices && presentation && presentationPrices[presentation]) {
    return presentationPrices[presentation];
  }

  return producto.priceBase || producto.precioBase || producto.price || 0;
};

export const openProductModal = ({
  rootSelector,
  producto,
  presentation,
  isStoreOpen = true,
  onAdd,
}) => {
  const root = document.querySelector(rootSelector);
  if (!root) return;

  const price = getPrice(producto, presentation);
  const inStock = producto.disponible !== false;
  const canAdd = inStock && isStoreOpen;
  const buttonLabel = !inStock
    ? "Sin stock"
    : !isStoreOpen
      ? "Fuera de horario"
      : "Agregar al pedido";
  const statusLabel = !inStock
    ? "Producto sin stock"
    : !isStoreOpen
      ? "Pedidos fuera de horario"
      : "Disponible para pedir";
  const modalId = String(producto.id || producto.nombre || "producto")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");
  const titleId = `modal-title-${modalId}`;
  const descriptionId = `modal-description-${modalId}`;
  const previousFocusedElement = document.activeElement;
  const imageUrl =
    producto.imageUrl ||
    producto.imagen ||
    `https://placehold.co/800x600?text=${encodeURIComponent(producto.nombre || producto.name || "Pizza")}`;

  root.innerHTML = `
    <div class="modal is-open" role="dialog" aria-modal="true" aria-labelledby="${titleId}" aria-describedby="${descriptionId}">
      <div class="modal__overlay" data-action="close" aria-hidden="true"></div>
      <div class="modal__content modal__content--product" role="document">
        <div class="modal__header-bar">
          <p class="modal__eyebrow">Detalle del producto</p>
          <button class="modal__close" type="button" data-action="close" aria-label="Cerrar detalle del producto">
            Cerrar
          </button>
        </div>

        <div class="modal__body-scroll">
          <div class="modal__hero">
            <div class="modal__media">
              <img
                src="${escapeHtml(imageUrl)}"
                alt="${escapeHtml(producto.nombre || producto.name || "Producto")}"
                class="modal__image"
                loading="lazy"
                decoding="async"
              >
            </div>

            <div class="modal__body">
              <h3 id="${titleId}" class="modal__title">${escapeHtml(producto.nombre || producto.name || "Producto")}</h3>
              <div class="modal__meta">
                <span>${escapeHtml(producto.categoria || producto.category || "Producto")}</span>
                <span>${escapeHtml(presentationLabels[presentation] || presentation || "Presentación única")}</span>
                <span class="modal__status ${canAdd ? "modal__status--available" : "modal__status--muted"}">${statusLabel}</span>
              </div>
              <p id="${descriptionId}" class="modal__description">
                ${escapeHtml(producto.descripcion || producto.description || "Sin descripción disponible.")}
              </p>
            </div>
          </div>
        </div>

        <div class="modal__footer">
          <div class="modal__price-block">
            <span class="modal__price-label">Precio</span>
            <strong class="modal__price">${formatPrice(price)}</strong>
          </div>
          <button
            class="btn btn--primary modal__add-button"
            type="button"
            data-action="add"
            ${canAdd ? "" : "disabled"}
          >
            ${buttonLabel}
          </button>
        </div>
      </div>
    </div>
  `;

  document.body.classList.add("has-modal-open");

  const getFocusableElements = () =>
    Array.from(
      root.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    );

  const handleClose = () => {
    root.removeEventListener("click", handleClick);
    window.removeEventListener("keydown", handleKeydown);
    root.innerHTML = "";
    document.body.classList.remove("has-modal-open");

    if (previousFocusedElement && typeof previousFocusedElement.focus === "function") {
      previousFocusedElement.focus();
    }
  };

  const handleClick = (event) => {
    const action = event.target?.dataset?.action;
    if (!action) return;

    if (action === "close") {
      handleClose();
      return;
    }

    if (action === "add" && canAdd) {
      onAdd?.();
      handleClose();
    }
  };

  const handleKeydown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      handleClose();
      return;
    }

    if (event.key !== "Tab") return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  // Cierra al tocar el área oscura del sheet (solo si el gesto no fue scroll interno)
  let touchStartedInsideContent = false;
  root.addEventListener(
    "touchstart",
    (event) => {
      touchStartedInsideContent = Boolean(event.target?.closest?.(".modal__content"));
    },
    { passive: true }
  );
  root.addEventListener(
    "touchend",
    (event) => {
      if (event.target?.dataset?.action !== "close") return;
      if (touchStartedInsideContent) return;
      handleClose();
    },
    { passive: true }
  );

  root.addEventListener("click", handleClick);
  window.addEventListener("keydown", handleKeydown);
  root.querySelector(".modal__close")?.focus();
};
